module.exports = __webpack_public_path__ + "static/media/background6.6eb032f8.jpg";